'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'wand-magic-sparkles';
var width = 576;
var height = 512;
var aliases = ["magic-wand-sparkles"];
var unicode = 'e2ca';
var svgPathData = 'M272-8c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24-24 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0 0 24c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0 0-24zM460 32c5.6 0 10.9 2.2 14.8 6.1l31 31c3.9 3.9 6.1 9.3 6.1 14.8s-2.2 10.9-6.1 14.8L393.7 211 333 150.3 445.2 38.1c3.9-3.9 9.3-6.1 14.8-6.1zM70.1 413.2L310.3 173 371 233.7 130.8 473.9c-3.9 3.9-9.3 6.1-14.8 6.1s-10.9-2.2-14.8-6.1l-31-31 0 0c-3.9-3.9-6.1-9.3-6.1-14.8s2.2-10.9 6.1-14.8zM460 0c-14 0-27.5 5.6-37.5 15.5l-375 375C37.6 400.5 32 414 32 428s5.6 27.5 15.5 37.5l31 31C88.5 506.4 102 512 116 512s27.5-5.6 37.5-15.5l375-375C538.4 111.5 544 98 544 84s-5.6-27.5-15.5-37.5l-31-31C487.5 5.6 474 0 460 0zM112 48c0-8.8-7.2-16-16-16S80 39.2 80 48l0 64-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-64zM464 304c-8.8 0-16 7.2-16 16l0 64-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-64c0-8.8-7.2-16-16-16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faWandMagicSparkles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;